export default {fields:{id:{},allFields:{},fields:{}}}